import React from 'react';
import { motion } from 'framer-motion';
import { GoldParticles } from './GoldParticles';
export function CTASection() {
  return <section className="relative min-h-screen w-full flex items-center justify-center overflow-hidden" data-id="element-8">
      {/* Background */}
      <div className="absolute inset-0" style={{
      background: 'radial-gradient(ellipse 70% 50% at 50% 50%, rgba(212,175,55,0.06) 0%, transparent 50%)'
    }} aria-hidden="true" data-id="element-9" />

      <GoldParticles density={30} speed={0.3} data-id="element-10" />

      <div className="relative z-10 text-center px-6 max-w-4xl mx-auto" data-id="element-11">
        <motion.h2 className="font-heading font-bold text-3xl sm:text-4xl md:text-5xl lg:text-6xl text-white mb-6 leading-tight" initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.3
      }} transition={{
        duration: 0.8,
        ease: [0.22, 1, 0.36, 1]
      }} data-id="element-12">
          Ready to Predict the Future of Gaming?
        </motion.h2>

        <motion.p className="font-body text-lg md:text-xl text-white/60 mb-12 max-w-2xl mx-auto" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.3
      }} transition={{
        delay: 0.2,
        duration: 0.7,
        ease: 'easeOut'
      }} data-id="element-13">
          Join the operators who stopped guessing and started knowing.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true,
        amount: 0.3
      }} transition={{
        delay: 0.4,
        duration: 0.6,
        ease: 'easeOut'
      }} data-id="element-14">
          <button className="
              font-heading text-base md:text-lg uppercase tracking-wider
              px-10 md:px-14 py-5 md:py-6
              border-2 border-ultra-gold bg-transparent text-ultra-gold
              rounded-sm
              pulse-gold-border
              transition-all duration-500 ease-out
              hover:bg-ultra-gold hover:text-ultra-black
              focus:outline-none focus:ring-2 focus:ring-ultra-gold/50 focus:ring-offset-2 focus:ring-offset-ultra-black
              cursor-pointer
            " type="button" data-id="element-15">
            Request a Demo
          </button>
        </motion.div>

        <motion.p className="font-body text-sm text-white/25 mt-10" initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true,
        amount: 0.3
      }} transition={{
        delay: 0.6,
        duration: 0.6
      }} data-id="element-16">
          hello@ultragamer.ai&ensp;•&ensp;Limassol, Cyprus
        </motion.p>
      </div>
    </section>;
}